// extracted by mini-css-extract-plugin
module.exports = {"confirmation_content_wrap":"Confirmation_confirmation_content_wrap__1GApA","text_sty":"Confirmation_text_sty__1YPam"};